import React, { useRef } from "react"
import { Heading } from "../common/Heading"
import { contact } from "../data/dummydata"
import emailjs from '@emailjs/browser';

export const Contact = ({language}) => {
  const form = useRef()
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_rxlixgl', 'template_9bhf92g', form.current, '7efEPn9CVIOfI1lug')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset()
  };

  return (
    
      <div className='contact'>
      
          <Heading title={language!==false?'Keep In Touch': "Contáctame"} />
          <div className='contact-content'>
            <div className='right'>
              <form ref={form} onSubmit={sendEmail}>
                <div className='flex'>
                  <input type='text' placeholder='Full Name' name="user_name" data-aos='flip-left' required />
                  <input type='email' placeholder='Email' name="user_email" data-aos='flip-right' />
                </div>
                <input type='text' placeholder='Subject' name="subject" data-aos='flip-up' />
                <textarea name='message' cols='30' rows='10' data-aos='flip-down'></textarea>
                <button type="submit" data-aos='zoom-in-up'>{language!==false?'Send Message': "Enviar mensaje"}</button>
              </form>
            </div>
            <div className='left'>
              {contact.map((item,i) => (
                <div key={i} className='box' data-aos='zoom-in'>
                  <i>{item.icon}</i>
                  <p>{item.text1}</p>
                </div>
              ))}
            </div>
          </div>
   
      </div>
   
  )
}
